<section
  class="bbm-page bbm-clinic-calendar-page"
  [class.rtl]="isAr"
  [class.bbm-is-en]="!isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-hero-copy">

          @if (!isSubAdmin) {
            <span class="bbm-badge">
              <i class="fa-solid fa-boxes-stacked"></i>

              {{ labels.totalGoods }}:
              <strong>
                {{ formatMoney(warehouseTotalValue) }}
              </strong>
              {{ labels.currency }}
            </span>
          }

          <h2>
            {{ getPageTitle() }}
          </h2>

          <p>
            {{ getPageSubtitle() }}
          </p>

        </div>

      </div>

      <!-- QUICK ACTIONS -->
      <div class="bbm-actions-grid bbm-actions-three bbm-hero-actions">

        <button
          type="button"
          class="bbm-action-btn bbm-action-primary"
          (click)="openQuickActionModal('order')"
        >
          <i class="fa-solid fa-cart-plus"></i>
          <span>{{ labels.newOrder }}</span>
        </button>

        <button
          type="button"
          class="bbm-action-btn bbm-action-primary"
          (click)="openQuickActionModal('booking')"
        >
          <i class="fa-solid fa-calendar-plus"></i>
          <span>{{ labels.newBooking }}</span>
        </button>

        @if (!isSubAdmin) {
          <button
            type="button"
            class="bbm-action-btn bbm-action-success"
            (click)="openQuickActionModal('shifts')"
          >
            <i class="fa-solid fa-clock"></i>
            <span>{{ labels.supply }}</span>
          </button>

          <button
            type="button"
            class="bbm-action-btn"
            (click)="openQuickActionModal('accounts')"
          >
            <i class="fa-solid fa-wallet"></i>
            <span>{{ labels.accounts }}</span>
          </button>
        }

      </div>

      <!-- MONTH SUMMARY -->
      <div class="bbm-calendar-summary-grid">

        @if (!isSubAdmin) {
          <button
            type="button"
            class="bbm-calendar-summary-btn"
            (click)="openMonthlyPopup('shifts')"
          >
            <strong>
              <i class="fa-solid fa-clock"></i>
              {{ formatNumber(getCurrentMonthShiftsTotal()) }}
            </strong>

            <span>
              {{ 'clinicCalendarSummary.shifts' | transloco }}
            </span>
          </button>
        }

        <button
          type="button"
          class="bbm-calendar-summary-btn"
          [class.bbm-alert-pulse]="isMonthlyBookingsAlerting()"
          (click)="openMonthlyPopup('bookings', $event)"
        >
          <strong>
            <i class="fa-solid fa-calendar-check"></i>
            {{ formatNumber(getCurrentMonthBookingsTotal()) }}
          </strong>

          <span>
            {{ 'clinicCalendarSummary.bookings' | transloco }}
          </span>
        </button>

        <button
          type="button"
          class="bbm-calendar-summary-btn"
          (click)="openMonthlyPopup('orders')"
        >
          <strong>
            <i class="fa-solid fa-receipt"></i>
            {{ formatNumber(getCurrentMonthOrdersTotal()) }}
          </strong>

          <span>
            {{ labels.orders }}
          </span>
        </button>

        <button
          type="button"
          class="bbm-calendar-summary-btn"
          (click)="openMonthlyPopup('vaccinations')"
        >
          <strong>
            <i class="fa-solid fa-syringe"></i>
            {{ formatNumber(getCurrentMonthVaccinationsTotal()) }}
          </strong>

          <span>
            {{ 'clinicCalendarSummary.vaccinations' | transloco }}
          </span>
        </button>

      </div>

    </section>

    <!-- CALENDAR -->
    <section class="bbm-form-ticket">

      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ labels.monthHint }}
          </span>

          <h3>
            {{ getMonthTitle() }}
          </h3>
        </div>
      </div>

      @if (loading) {
        <div class="bbm-loader">
          <span class="bbm-loader-spinner"></span>
          <span>{{ labels.loading }}</span>
        </div>
      }

      @if (serverError && !loading) {
        <div class="bbm-alert bbm-alert-danger">
          <i class="fa-solid fa-circle-exclamation"></i>
          <span>{{ serverError }}</span>
        </div>
      }

      @if (!loading && !serverError) {
        <div class="bbm-calendar-board">

          <div class="bbm-calendar-grid">

            @for (
              day of calendarDays;
              track trackByDay($index, day)
            ) {
              <article
                class="bbm-calendar-day"
                [class.bbm-calendar-day-other]="!day.isCurrentMonth"
                [class.bbm-calendar-day-today]="day.isToday"
                [class.bbm-calendar-day-open]="
                  day.is_open &&
                  day.shifts.length > 0
                "
                [class.bbm-calendar-day-closed]="
                  !day.is_open ||
                  day.shifts.length === 0
                "
              >

                <div class="bbm-calendar-day-head">

                  <span class="bbm-calendar-day-number">
                    {{ formatNumber(day.dayNumber) }}
                  </span>

                  <span class="bbm-calendar-day-name">
                    {{ day.dayLabel }}
                  </span>

                  @if (day.isToday) {
                    <span class="bbm-badge">
                      {{ labels.today }}
                    </span>
                  }

                </div>

                <div class="bbm-calendar-day-content">

                  @if (
                    day.bookings.length > 0 ||
                    day.ordersCount > 0 ||
                    day.vaccinations.length > 0 ||
                    (
                      !isSubAdmin &&
                      day.is_open &&
                      day.shifts.length > 0
                    )
                  ) {
                    <div class="bbm-calendar-counters">

                      @if (
                        !isSubAdmin &&
                        day.is_open &&
                        day.shifts.length > 0
                      ) {
                        <button
                          type="button"
                          class="
                            bbm-calendar-counter-btn
                            bbm-calendar-counter-success
                          "
                          [title]="labels.shifts"
                          (click)="openShiftsPopup(day)"
                        >
                          <i class="fa-solid fa-clock"></i>
                          <span>
                            {{ formatNumber(day.shifts.length) }}
                          </span>
                        </button>
                      }

                      @if (day.bookings.length > 0) {
                        <button
                          type="button"
                          class="
                            bbm-calendar-counter-btn
                            bbm-calendar-counter-primary
                          "
                          [class.bbm-alert-pulse]="
                            isCounterAlerting(day, 'bookings')
                          "
                          [title]="labels.bookings"
                          (click)="openBookingsPopup(day, $event)"
                        >
                          <i class="fa-solid fa-calendar-check"></i>
                          <span>
                            {{ formatNumber(day.bookings.length) }}
                          </span>
                        </button>
                      }

                      @if (day.ordersCount > 0) {
                        <button
                          type="button"
                          class="
                            bbm-calendar-counter-btn
                            bbm-calendar-counter-warning
                          "
                          [title]="labels.orders"
                          (click)="openOrdersPopup(day)"
                        >
                          <i class="fa-solid fa-receipt"></i>
                          <span>
                            {{ formatNumber(day.ordersCount) }}
                          </span>
                        </button>
                      }

                      @if (day.vaccinations.length > 0) {
                        <button
                          type="button"
                          class="
                            bbm-calendar-counter-btn
                            bbm-calendar-counter-danger
                          "
                          [class.bbm-alert-pulse]="
                            isCounterAlerting(day, 'vaccinations')
                          "
                          [title]="labels.vaccinations"
                          (click)="openVaccinationsPopup(day)"
                        >
                          <i class="fa-solid fa-syringe"></i>
                          <span>
                            {{ formatNumber(day.vaccinations.length) }}
                          </span>
                        </button>
                      }

                    </div>
                  }

                  @if (
                    !day.is_open ||
                    day.shifts.length === 0
                  ) {
                    <div class="bbm-calendar-closed-state">
                      {{ labels.closed }}
                    </div>
                  }

                </div>

              </article>
            }

          </div>

          <div class="bbm-calendar-nav">

            <button
              type="button"
              class="bbm-action-btn"
              (click)="goPreviousMonth()"
            >
              <i
                class="fa-solid"
                [class.fa-chevron-right]="isAr"
                [class.fa-chevron-left]="!isAr"
              ></i>

              <span>
                {{ labels.previousMonth }}
              </span>
            </button>

            <button
              type="button"
              class="bbm-action-btn bbm-action-primary"
              (click)="goToday()"
            >
              <i class="fa-regular fa-calendar-check"></i>

              <span>
                {{ labels.currentMonth }}
              </span>
            </button>

            <button
              type="button"
              class="bbm-action-btn"
              (click)="goNextMonth()"
            >
              <span>
                {{ labels.nextMonth }}
              </span>

              <i
                class="fa-solid"
                [class.fa-chevron-left]="isAr"
                [class.fa-chevron-right]="!isAr"
              ></i>
            </button>

          </div>

        </div>
      }

    </section>

  </div>

  <!-- DAY POPUP -->
  @if (selectedDay && selectedPopupType) {
    <div
      class="bbm-modal-backdrop"
      (click)="closeDayPopup()"
    >
      <section
        class="bbm-modal-card bbm-calendar-modal"
        (click)="$event.stopPropagation()"
      >

        <div class="bbm-modal-handle"></div>

        <div class="bbm-form-head">

          <div>
            <span class="bbm-eyebrow">
              {{ getSelectedDayTitle() }}
            </span>

            <h3>
              @if (selectedPopupType === 'bookings') {
                {{ labels.bookings }}
              } @else if (selectedPopupType === 'shifts') {
                {{ labels.shifts }}
              } @else if (selectedPopupType === 'orders') {
                {{ labels.orders }}
              } @else {
                {{ labels.vaccinations }}
              }
            </h3>
          </div>

          <button
            type="button"
            class="
              bbm-action-btn
              bbm-action-danger
              bbm-icon-action
            "
            (click)="closeDayPopup()"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>

        </div>

        <div class="bbm-modal-list">

          <!-- BOOKINGS -->
          @if (selectedPopupType === 'bookings') {
            <div class="bbm-calendar-popup-list">

              @for (
                booking of selectedDay.bookings;
                track booking.id
              ) {
                <article
                  class="
                    bbm-calendar-popup-item
                    bbm-calendar-popup-booking
                  "
                  role="button"
                  tabindex="0"
                  (click)="
                    acknowledgeBookingAlert(
                      booking,
                      $event
                    )
                  "
                  (keydown.enter)="
                    acknowledgeBookingAlert(
                      booking,
                      $event
                    )
                  "
                >

                  <div class="bbm-calendar-popup-top">

                    <div class="bbm-calendar-text-stack">
                      <strong>
                        {{ booking.clientName }}
                      </strong>

                      <span>
                        {{ booking.serviceName }}
                      </span>

                      @if (booking.phone) {
                        <a [href]="'tel:' + booking.phone">
                          <i class="fa-solid fa-phone"></i>
                          {{ booking.phone }}
                        </a>
                      }
                    </div>

                    <div class="bbm-calendar-popup-meta">

                      <span class="bbm-badge">
                        {{ formatBookingTime(booking) }}
                      </span>

                      <small
                        class="bbm-badge booking-status"
                        [ngClass]="
                          getBookingStatusClass(
                            booking.status
                          )
                        "
                      >
                        {{
                          getBookingStatusLabel(
                            booking.status
                          )
                        }}
                      </small>

                    </div>

                  </div>

                  <div
                    class="bbm-calendar-actions"
                    (click)="$event.stopPropagation()"
                  >

                    @if (!isFinalStatus(booking.status)) {

                      @if (booking.status !== 1) {
                        <button
                          type="button"
                          class="
                            bbm-action-btn
                            bbm-action-success
                            bbm-action-compact
                          "
                          (click)="
                            setBookingStatus(
                              booking,
                              1
                            )
                          "
                        >
                          {{ labels.approved }}
                        </button>
                      }

                      @if (booking.status !== 4) {
                        <button
                          type="button"
                          class="
                            bbm-action-btn
                            bbm-action-success
                            bbm-action-compact
                          "
                          (click)="
                            setBookingStatus(
                              booking,
                              4
                            )
                          "
                        >
                          {{ labels.completed }}
                        </button>
                      }

                      <button
                        type="button"
                        class="
                          bbm-action-btn
                          bbm-action-warning
                          bbm-action-compact
                        "
                        (click)="
                          openDeferredDatePopup(booking)
                        "
                      >
                        @if (booking.status === 3) {
                          {{ labels.changeDeferredDate }}
                        } @else {
                          {{ labels.deferred }}
                        }
                      </button>

                      @if (booking.status !== 2) {
                        <button
                          type="button"
                          class="
                            bbm-action-btn
                            bbm-action-danger
                            bbm-action-compact
                          "
                          (click)="
                            setBookingStatus(
                              booking,
                              2
                            )
                          "
                        >
                          {{ labels.rejected }}
                        </button>
                      }
                    }

                    <button
                      type="button"
                      class="
                        bbm-action-btn
                        bbm-action-danger
                        bbm-action-compact
                      "
                      (click)="deleteBooking(booking)"
                    >
                      <i class="fa-regular fa-trash-can"></i>
                      {{ labels.delete }}
                    </button>

                  </div>

                </article>
              }

            </div>
          }

          <!-- ORDERS -->
          @if (selectedPopupType === 'orders') {

            <div class="bbm-calendar-summary-box">
              <span>
                {{ labels.totalInvoicesMoney }}:
              </span>

              <strong>
                {{
                  formatMoney(
                    selectedDay.ordersTotalMoney
                  )
                }}
                {{ labels.currency }}
              </strong>
            </div>

            <div class="bbm-calendar-popup-list">

              @for (
                order of selectedDay.orders;
                track order.id
              ) {
                <article
                  class="
                    bbm-calendar-popup-item
                    bbm-calendar-popup-order
                  "
                  role="button"
                  tabindex="0"
                  (click)="
                    openOrderInvoicePopup(
                      order,
                      $event
                    )
                  "
                  (keydown.enter)="
                    openOrderInvoicePopup(
                      order,
                      $event
                    )
                  "
                >

                  <div class="bbm-calendar-text-stack">
                    <span>
                      {{ labels.invoiceNumber }}
                    </span>

                    <strong>
                      #{{ formatNumber(order.id) }}
                    </strong>

                    <span>
                      {{ order.clientName }}
                    </span>

                    @if (order.phone) {
                      <a
                        [href]="'tel:' + order.phone"
                        (click)="$event.stopPropagation()"
                      >
                        {{ order.phone }}
                      </a>
                    }
                  </div>

                  <div class="bbm-calendar-order-meta">

                    <div>
                      <span>
                        {{ labels.invoiceAmount }}
                      </span>

                      <strong>
                        {{ formatMoney(order.total) }}
                        {{ labels.currency }}
                      </strong>
                    </div>

                    <div>
                      <span>
                        {{ labels.orderTime }}
                      </span>

                      <strong>
                        {{ formatOrderTime(order) }}
                      </strong>
                    </div>

                  </div>

                </article>
              }

            </div>
          }

          <!-- VACCINATIONS -->
          @if (selectedPopupType === 'vaccinations') {
            <div class="bbm-calendar-popup-list">

              @for (
                vaccination of selectedDay.vaccinations;
                track vaccination.id
              ) {
                <a
                  class="
                    bbm-calendar-popup-item
                    bbm-calendar-popup-vaccination
                  "
                  [routerLink]="
                    vaccination.petId
                      ? ['/petvaccinations']
                      : null
                  "
                  [queryParams]="
                    vaccination.petId
                      ? { petId: vaccination.petId }
                      : null
                  "
                >
                  <div class="bbm-calendar-popup-top">

                    <div class="bbm-calendar-text-stack">
                      <strong>
                        {{ vaccination.vaccineName }}
                      </strong>

                      <span>
                        {{ vaccination.petName }}
                      </span>
                    </div>

                    <span class="
                      bbm-status-pill
                      bbm-status-danger
                    ">
                      <i class="fa-solid fa-syringe"></i>
                    </span>

                  </div>
                </a>
              }

            </div>
          }

          <!-- SHIFTS -->
          @if (selectedPopupType === 'shifts') {
            <div class="bbm-calendar-popup-list">

              @for (
                shift of selectedDay.shifts;
                track trackByShift($index, shift)
              ) {
                <article
                  class="
                    bbm-calendar-popup-item
                    bbm-calendar-popup-shift
                  "
                >

                  <div class="bbm-calendar-popup-top">

                    <div class="bbm-calendar-text-stack">
                      <strong>
                        {{ labels.shiftTime }}
                      </strong>

                      <span>
                        {{ formatShift(shift) }}
                      </span>

                      @if (isEmergencyShift(shift)) {
                        <small class="
                          bbm-badge
                          bbm-badge-warning
                        ">
                          {{ getEmergencyShiftLabel() }}
                        </small>
                      }
                    </div>

                    <span class="
                      bbm-status-pill
                      bbm-status-success
                    ">
                      <i class="fa-solid fa-users"></i>

                      {{
                        formatNumber(
                          getShiftUsersCount(shift)
                        )
                      }}

                      {{ labels.employeesCount }}
                    </span>

                  </div>

                  <div class="bbm-calendar-section">

                    <div class="bbm-calendar-section-head">
                      <strong>
                        {{ labels.shiftEmployees }}
                      </strong>

                      <span class="
                        bbm-badge
                        bbm-badge-success
                      ">
                        {{
                          formatNumber(
                            getShiftUsersCount(shift)
                          )
                        }}
                        {{ labels.employeesCount }}
                      </span>
                    </div>

                    @if (
                      getShiftUsersForView(shift).length
                    ) {
                      <div class="bbm-shift-users">

                        @for (
                          user of getShiftUsersForView(shift);
                          track trackByShiftUser(
                            $index,
                            user
                          )
                        ) {
                          <div class="bbm-shift-user-wrap">

                            <button
                              type="button"
                              class="bbm-shift-user-chip"
                              [class.is-active]="
                                isShiftUserActionsOpen(
                                  shift,
                                  user
                                )
                              "
                              [class.is-disabled]="
                                isShiftUserDisabled(user)
                              "
                              [disabled]="
                                isShiftUserDisabled(user)
                              "
                              (click)="
                                !isShiftUserDisabled(user) &&
                                toggleShiftUserActions(
                                  shift,
                                  user,
                                  $event
                                )
                              "
                            >
                              <i class="fa-solid fa-user"></i>

                              {{ getShiftUserName(user) }}

                              @if (
                                isShiftUserDisabled(user)
                              ) {
                                <small>
                                  {{ 'Base' | transloco }}
                                </small>
                              }
                            </button>

                            @if (
                              isShiftUserActionsOpen(
                                shift,
                                user
                              )
                            ) {
                              <div
                                class="bbm-shift-user-actions"
                                (click)="$event.stopPropagation()"
                              >

                                <button
                                  type="button"
                                  class="
                                    bbm-action-btn
                                    bbm-action-compact
                                  "
                                  routerLink="/employee"
                                  [queryParams]="
                                    getEmployeeDetailsQueryParams(
                                      user
                                    )
                                  "
                                >
                                  <i class="fa-solid fa-id-card"></i>
                                  {{ labels.employeeDetails }}
                                </button>

                                <button
                                  type="button"
                                  class="
                                    bbm-action-btn
                                    bbm-action-primary
                                    bbm-action-compact
                                  "
                                  routerLink="/employeescollecting"
                                  [queryParams]="
                                    getEmployeeSalesQueryParams(
                                      user
                                    )
                                  "
                                >
                                  <i class="fa-solid fa-chart-line"></i>
                                  {{ labels.employeeSales }}
                                </button>

                              </div>
                            }

                          </div>
                        }

                      </div>
                    } @else {
                      <span class="bbm-badge">
                        {{ labels.noShiftEmployees }}
                      </span>
                    }

                  </div>

                  <div class="bbm-calendar-money-grid">

                    <div class="bbm-calendar-money-item">
                      <span>{{ labels.shiftSales }}</span>

                      <strong>
                        {{
                          formatMoney(
                            getShiftSalesTotal(
                              selectedDay.date,
                              shift
                            )
                          )
                        }}
                        {{ labels.currency }}
                      </strong>
                    </div>

                    <div class="
                      bbm-calendar-money-item
                      is-expense
                    ">
                      <span>
                        {{ labels.shiftExpenses }}
                      </span>

                      <strong>
                        {{
                          formatMoney(
                            getShiftExpensesTotal(
                              selectedDay.date,
                              shift
                            )
                          )
                        }}
                        {{ labels.currency }}
                      </strong>
                    </div>

                    <div
                      class="bbm-calendar-money-item"
                      [class.is-profit]="
                        getShiftProfitTotal(
                          selectedDay.date,
                          shift
                        ) >= 0
                      "
                      [class.is-negative]="
                        getShiftProfitTotal(
                          selectedDay.date,
                          shift
                        ) < 0
                      "
                    >
                      <span>
                        {{ labels.shiftProfit }}
                      </span>

                      <strong>
                        {{
                          formatMoney(
                            getShiftProfitTotal(
                              selectedDay.date,
                              shift
                            )
                          )
                        }}
                        {{ labels.currency }}
                      </strong>
                    </div>

                  </div>

                </article>
              }

            </div>
          }

        </div>

      </section>
    </div>
  }

  <!-- MONTHLY POPUP -->
  @if (selectedMonthlyPopupType) {
    <div
      class="bbm-modal-backdrop"
      (click)="closeMonthlyPopup()"
    >
      <section
        class="
          bbm-modal-card
          bbm-calendar-modal-lg
        "
        (click)="$event.stopPropagation()"
      >

        <div class="bbm-modal-handle"></div>

        <div class="bbm-form-head">
          <div>
            <span class="bbm-eyebrow">
              {{ getMonthTitle() }}
            </span>

            <h3>
              {{ getMonthlyPopupTitle() }}
            </h3>
          </div>

          <button
            type="button"
            class="
              bbm-action-btn
              bbm-action-danger
              bbm-icon-action
            "
            (click)="closeMonthlyPopup()"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div class="bbm-modal-list">

          <!-- MONTHLY ORDERS -->
          @if (
            selectedMonthlyPopupType === 'orders'
          ) {

            <div class="bbm-calendar-summary-box">
              <span>
                {{ labels.totalInvoicesMoney }}:
              </span>

              <strong>
                {{
                  formatMoney(
                    getCurrentMonthOrdersMoneyTotal()
                  )
                }}
                {{ labels.currency }}
              </strong>
            </div>

            <div class="bbm-calendar-popup-list">

              @for (
                order of getCurrentMonthOrders();
                track order.id
              ) {
                <article
                  class="
                    bbm-calendar-popup-item
                    bbm-calendar-popup-order
                  "
                  role="button"
                  tabindex="0"
                  (click)="
                    openOrderInvoicePopup(
                      order,
                      $event
                    )
                  "
                  (keydown.enter)="
                    openOrderInvoicePopup(
                      order,
                      $event
                    )
                  "
                >

                  <div class="bbm-calendar-text-stack">
                    <span>
                      {{ labels.invoiceNumber }}
                    </span>

                    <strong>
                      #{{ formatNumber(order.id) }}
                    </strong>

                    <span>
                      {{ order.clientName }}
                    </span>

                    @if (order.phone) {
                      <a
                        [href]="'tel:' + order.phone"
                        (click)="$event.stopPropagation()"
                      >
                        {{ order.phone }}
                      </a>
                    }
                  </div>

                  <div class="bbm-calendar-order-meta">

                    <div>
                      <span>
                        {{ labels.invoiceAmount }}
                      </span>

                      <strong>
                        {{ formatMoney(order.total) }}
                        {{ labels.currency }}
                      </strong>
                    </div>

                    <div>
                      <span>
                        {{ labels.invoiceDate }}
                      </span>

                      <strong>
                        {{ formatOrderDateTime(order) }}
                      </strong>
                    </div>

                  </div>

                </article>
              }

            </div>
          }

          <!-- MONTHLY BOOKINGS -->
          @if (
            selectedMonthlyPopupType === 'bookings'
          ) {
            <div class="bbm-calendar-popup-list">

              @for (
                booking of getCurrentMonthBookings();
                track booking.id
              ) {
                <article
                  class="
                    bbm-calendar-popup-item
                    bbm-calendar-popup-booking
                  "
                  role="button"
                  tabindex="0"
                  (click)="
                    acknowledgeBookingAlert(
                      booking,
                      $event
                    )
                  "
                  (keydown.enter)="
                    acknowledgeBookingAlert(
                      booking,
                      $event
                    )
                  "
                >

                  <div class="bbm-calendar-popup-top">

                    <div class="bbm-calendar-text-stack">
                      <strong>
                        {{ booking.clientName }}
                      </strong>

                      <span>
                        {{ booking.serviceName }}
                      </span>

                      @if (booking.phone) {
                        <a [href]="'tel:' + booking.phone">
                          {{ booking.phone }}
                        </a>
                      }
                    </div>

                    <div class="bbm-calendar-popup-meta">
                      <span class="bbm-badge">
                        {{ formatDateTime(booking.date) }}
                      </span>

                      <small
                        class="bbm-badge booking-status"
                        [ngClass]="
                          getBookingStatusClass(
                            booking.status
                          )
                        "
                      >
                        {{
                          getBookingStatusLabel(
                            booking.status
                          )
                        }}
                      </small>
                    </div>

                  </div>

                </article>
              }

            </div>
          }

          <!-- MONTHLY VACCINATIONS -->
          @if (
            selectedMonthlyPopupType ===
            'vaccinations'
          ) {
            <div class="bbm-calendar-popup-list">

              @for (
                vaccination of
                  getCurrentMonthVaccinations();
                track vaccination.id
              ) {
                <a
                  class="
                    bbm-calendar-popup-item
                    bbm-calendar-popup-vaccination
                  "
                  [routerLink]="
                    vaccination.petId
                      ? ['/petvaccinations']
                      : null
                  "
                  [queryParams]="
                    vaccination.petId
                      ? { petId: vaccination.petId }
                      : null
                  "
                >

                  <div class="bbm-calendar-popup-top">

                    <div class="bbm-calendar-text-stack">
                      <strong>
                        {{ vaccination.vaccineName }}
                      </strong>

                      <span>
                        {{ vaccination.petName }}
                      </span>
                    </div>

                    <div class="bbm-calendar-popup-meta">
                      <span class="
                        bbm-badge
                        bbm-badge-danger
                      ">
                        {{
                          formatDateTime(
                            vaccination.date
                          )
                        }}
                      </span>

                      <i class="fa-solid fa-syringe"></i>
                    </div>

                  </div>

                </a>
              }

            </div>
          }

          <!-- MONTHLY SHIFTS -->
          @if (
            selectedMonthlyPopupType === 'shifts'
          ) {
            <div class="bbm-calendar-popup-list">

              @for (
                day of getCurrentMonthDaysWithShifts();
                track trackByDay($index, day)
              ) {
                <article
                  class="
                    bbm-calendar-popup-item
                    bbm-calendar-popup-shift
                  "
                >

                  <div class="bbm-calendar-popup-top">

                    <div class="bbm-calendar-text-stack">
                      <strong>
                        {{
                          getSelectedDayTitleForDate(
                            day.date
                          )
                        }}
                      </strong>

                      <span>
                        {{ formatNumber(day.shifts.length) }}
                        {{ labels.shifts }}
                      </span>
                    </div>

                    <span class="
                      bbm-status-pill
                      bbm-status-success
                    ">
                      <i class="fa-solid fa-clock"></i>
                    </span>

                  </div>

                  <div class="bbm-monthly-shifts">

                    @for (
                      shift of day.shifts;
                      track trackByShift(
                        $index,
                        shift
                      )
                    ) {
                      <div class="bbm-monthly-shift-row">

                        <strong>
                          {{ formatShift(shift) }}

                          @if (isEmergencyShift(shift)) {
                            <small class="
                              bbm-badge
                              bbm-badge-warning
                            ">
                              {{
                                getEmergencyShiftLabel()
                              }}
                            </small>
                          }
                        </strong>

                        <span class="
                          bbm-badge
                          bbm-badge-success
                        ">
                          {{
                            formatNumber(
                              getShiftUsersCount(shift)
                            )
                          }}
                          {{ labels.employeesCount }}
                        </span>

                        @if (
                          getShiftUsersForView(shift).length
                        ) {
                          <span>
                            {{
                              getShiftUserNames(shift)
                                .join(' - ')
                            }}
                          </span>
                        } @else {
                          <span>
                            {{ labels.noShiftEmployees }}
                          </span>
                        }

                        <div class="bbm-calendar-money-grid">

                          <div class="bbm-calendar-money-item">
                            <span>
                              {{ labels.shiftSales }}
                            </span>

                            <strong>
                              {{
                                formatMoney(
                                  getShiftSalesTotal(
                                    day.date,
                                    shift
                                  )
                                )
                              }}
                              {{ labels.currency }}
                            </strong>
                          </div>

                          <div class="
                            bbm-calendar-money-item
                            is-expense
                          ">
                            <span>
                              {{ labels.shiftExpenses }}
                            </span>

                            <strong>
                              {{
                                formatMoney(
                                  getShiftExpensesTotal(
                                    day.date,
                                    shift
                                  )
                                )
                              }}
                              {{ labels.currency }}
                            </strong>
                          </div>

                          <div
                            class="bbm-calendar-money-item"
                            [class.is-profit]="
                              getShiftProfitTotal(
                                day.date,
                                shift
                              ) >= 0
                            "
                            [class.is-negative]="
                              getShiftProfitTotal(
                                day.date,
                                shift
                              ) < 0
                            "
                          >
                            <span>
                              {{ labels.shiftProfit }}
                            </span>

                            <strong>
                              {{
                                formatMoney(
                                  getShiftProfitTotal(
                                    day.date,
                                    shift
                                  )
                                )
                              }}
                              {{ labels.currency }}
                            </strong>
                          </div>

                        </div>

                      </div>
                    }

                  </div>

                </article>
              }

            </div>
          }

        </div>

      </section>
    </div>
  }

  <!-- INVOICE POPUP -->
  @if (selectedInvoiceOrder; as invoiceOrder) {
    <div
      class="bbm-modal-backdrop"
      (click)="closeOrderInvoicePopup()"
    >
      <section
        class="
          bbm-modal-card
          bbm-calendar-invoice-modal
        "
        (click)="$event.stopPropagation()"
      >

        <div class="bbm-modal-handle"></div>

        <div class="bbm-form-head">
          <div>
            <span class="bbm-eyebrow">
              {{ labels.invoice }}
            </span>

            <h3>
              #{{ formatNumber(invoiceOrder.id) }}
            </h3>

            <p>
              {{ formatOrderDateTime(invoiceOrder) }}
            </p>
          </div>

          <button
            type="button"
            class="
              bbm-action-btn
              bbm-action-danger
              bbm-icon-action
            "
            (click)="closeOrderInvoicePopup()"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div class="bbm-modal-list">

          <div class="bbm-calendar-invoice-grid">

            <div class="bbm-detail-chip">
              <i class="fa-solid fa-user"></i>

              <span>
                {{ labels.customer }}
              </span>

              <strong>
                {{ invoiceOrder.clientName }}
              </strong>
            </div>

            @if (invoiceOrder.phone) {
              <div class="bbm-detail-chip">
                <i class="fa-solid fa-phone"></i>

                <span>
                  {{ labels.phoneLabel }}
                </span>

                <strong>
                  {{ invoiceOrder.phone }}
                </strong>
              </div>
            }

          </div>

          <div class="bbm-block-head">
            <span>
              {{ labels.invoiceItems }}
            </span>
          </div>

          @if (getInvoiceItems(invoiceOrder).length) {

            <div class="bbm-calendar-invoice-items">

              <div class="
                bbm-calendar-invoice-row
                bbm-calendar-invoice-head
              ">
                <span>{{ labels.product }}</span>
                <span>{{ labels.quantityLabel }}</span>
                <span>{{ labels.priceLabel }}</span>
                <span>{{ labels.lineTotalLabel }}</span>
              </div>

              @for (
                item of getInvoiceItems(invoiceOrder);
                track item.name + '-' + $index
              ) {
                <div class="bbm-calendar-invoice-row">
                  <strong>{{ item.name }}</strong>
                  <span>
                    {{ formatNumber(item.quantity) }}
                  </span>
                  <span>
                    {{ formatMoney(item.price) }}
                  </span>
                  <span>
                    {{ formatMoney(item.lineTotal) }}
                  </span>
                </div>
              }

            </div>

          } @else {
            <div class="bbm-empty-state">
              <i class="fa-solid fa-box-open"></i>
              <h4>{{ labels.noInvoiceItems }}</h4>
            </div>
          }

          <div class="bbm-calendar-invoice-totals">

            <div class="bbm-calendar-invoice-total-row">
              <span>
                {{ labels.subtotalLabel }}
              </span>

              <strong>
                {{
                  formatMoney(
                    getOrderSubtotal(invoiceOrder)
                  )
                }}
                {{ labels.currency }}
              </strong>
            </div>

            @if (
              getOrderDiscount(invoiceOrder) > 0
            ) {
              <div class="bbm-calendar-invoice-total-row">
                <span>
                  {{ labels.discountLabel }}
                </span>

                <strong>
                  -
                  {{
                    formatMoney(
                      getOrderDiscount(invoiceOrder)
                    )
                  }}
                  {{ labels.currency }}
                </strong>
              </div>
            }

            @if (
              getOrderDeliveryFees(invoiceOrder) > 0
            ) {
              <div class="bbm-calendar-invoice-total-row">
                <span>
                  {{ labels.deliveryFeesLabel }}
                </span>

                <strong>
                  {{
                    formatMoney(
                      getOrderDeliveryFees(
                        invoiceOrder
                      )
                    )
                  }}
                  {{ labels.currency }}
                </strong>
              </div>
            }

            @if (
              getOrderPaidAmount(invoiceOrder) > 0
            ) {
              <div class="bbm-calendar-invoice-total-row">
                <span>
                  {{ labels.paidLabel }}
                </span>

                <strong>
                  {{
                    formatMoney(
                      getOrderPaidAmount(
                        invoiceOrder
                      )
                    )
                  }}
                  {{ labels.currency }}
                </strong>
              </div>
            }

            @if (
              getOrderRemainingAmount(
                invoiceOrder
              ) > 0
            ) {
              <div class="bbm-calendar-invoice-total-row">
                <span>
                  {{ labels.remainingLabel }}
                </span>

                <strong>
                  {{
                    formatMoney(
                      getOrderRemainingAmount(
                        invoiceOrder
                      )
                    )
                  }}
                  {{ labels.currency }}
                </strong>
              </div>
            }

            <div class="
              bbm-calendar-invoice-total-row
              bbm-calendar-invoice-grand
            ">
              <span>
                {{ labels.totalInvoicesMoney }}
              </span>

              <strong>
                {{ formatMoney(invoiceOrder.total) }}
                {{ labels.currency }}
              </strong>
            </div>

          </div>

        </div>

      </section>
    </div>
  }

  <!-- DEFERRED DATE POPUP -->
  @if (showDeferredPopup) {
    <div
      class="bbm-modal-backdrop"
      (click)="closeDeferredPopup()"
    >
      <section
        class="bbm-modal-card"
        (click)="$event.stopPropagation()"
      >

        <div class="bbm-modal-handle"></div>

        <div class="bbm-form-head">
          <div>
            <span class="bbm-eyebrow">
              {{ labels.deferred }}
            </span>

            <h3>
              {{ labels.changeDeferredDate }}
            </h3>
          </div>

          <button
            type="button"
            class="
              bbm-action-btn
              bbm-action-danger
              bbm-icon-action
            "
            (click)="closeDeferredPopup()"
            [disabled]="isUpdatingStatus"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div class="bbm-modal-list">
          <div class="bbm-modal-row">
            <label for="deferred-booking-date">
              {{ labels.deferredDate }}
            </label>

            <input
              id="deferred-booking-date"
              class="bbm-control"
              type="datetime-local"
              [(ngModel)]="deferredBookingDate"
            >
          </div>
        </div>

        <div class="bbm-form-actions">

          <button
            type="button"
            class="bbm-action-btn"
            (click)="closeDeferredPopup()"
            [disabled]="isUpdatingStatus"
          >
            {{ labels.close }}
          </button>

          <button
            type="button"
            class="
              bbm-action-btn
              bbm-action-primary
            "
            (click)="submitDeferredDate()"
            [disabled]="
              isUpdatingStatus ||
              !deferredBookingDate
            "
          >
            @if (isUpdatingStatus) {
              <span class="bbm-loader-spinner"></span>
              {{ labels.loadingAction }}
            } @else {
              <i class="fa-solid fa-check"></i>
              {{ labels.submit }}
            }
          </button>

        </div>

      </section>
    </div>
  }

  <!-- QUICK COMPONENT MODAL -->
  @if (selectedQuickActionModal) {
    <div
      class="bbm-modal-backdrop"
      (click)="closeQuickActionModal()"
    >
      <section
        class="
          bbm-modal-card
          bbm-component-modal
        "
        (click)="$event.stopPropagation()"
      >

        <div class="bbm-form-head">
          <div>
            <span class="bbm-eyebrow">
              {{ getPageTitle() }}
            </span>

            <h3>
              {{ getQuickActionModalTitle() }}
            </h3>
          </div>

          <button
            type="button"
            class="
              bbm-action-btn
              bbm-action-danger
              bbm-icon-action
            "
            (click)="closeQuickActionModal()"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div class="bbm-component-modal-body">

          @if (
            selectedQuickActionModal === 'order'
          ) {
            <app-addorderstore></app-addorderstore>
          }

          @if (
            selectedQuickActionModal === 'booking'
          ) {
            <app-newbooking></app-newbooking>
          }

          @if (
            selectedQuickActionModal === 'shifts'
          ) {
            <app-clinic-emergency-shift>
            </app-clinic-emergency-shift>
          }

          @if (
            selectedQuickActionModal === 'accounts'
          ) {
            <app-dailyexpensespage>
            </app-dailyexpensespage>
          }

        </div>

      </section>
    </div>
  }

</section>